import React, { useState, useRef } from 'react'

interface AccordionItem {
  title: string
  content: string
}

export interface SportsBeerAccordionData {
  items: AccordionItem[]
}

const PlusIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <line y1="10.5" x2="21" y2="10.5" stroke="#3E2F3D" strokeWidth="3" />
    <line x1="10.5" y1="21" x2="10.5" stroke="#3E2F3D" strokeWidth="3" />
  </svg>
)

const MinusIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="3" viewBox="0 0 21 3" fill="none">
    <line y1="1.5" x2="21" y2="1.5" stroke="#3E2F3D" strokeWidth="3" />
  </svg>
)

interface AccordionItemProps {
  item: AccordionItem
  isOpen: boolean
  onToggle: () => void
}

const AccordionItemComponent: React.FC<AccordionItemProps> = ({ item, isOpen, onToggle }) => {
  const contentRef = useRef<HTMLDivElement>(null)

  return (
    <div className="overflow-hidden w-full max-w-[1010px] border-2 border-[#3E2F3D] bg-[#FF755A] shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
      <button
        type="button"
        className="w-full py-[19px] px-[16px] lg:px-[30px] flex justify-between items-center text-left text-gray-900 text-lg md:text-xl transition-colors"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span className="font-bn-dime normal-case text-[#3E2F3D]">{item.title}</span>
        <span>{isOpen ? <MinusIcon /> : <PlusIcon />}</span>
      </button>
      <div
        ref={contentRef}
        className="transition-all duration-300 ease-in-out bg-transparent overflow-hidden"
        style={{ maxHeight: isOpen ? `${contentRef.current?.scrollHeight ?? 0}px` : '0px' }}
        role="region"
      >
        <div
          className="text-[13px] lg:text-[18px] font-bookman pb-[19px] px-[16px] lg:px-[30px] text-[#3E2F3D]"
          dangerouslySetInnerHTML={{ __html: item.content }}
        />
      </div>
    </div>
  )
}

const SportsBeerAccordion: React.FC<SportsBeerAccordionData> = ({ items }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index))
  }

  if (!items?.length) return null

  return (
    <div className="space-y-[12px] lg:space-y-[24px] text-left place-items-center">
      {items.map((item, index) => (
        <AccordionItemComponent
          key={index}
          item={item}
          isOpen={openIndex === index}
          onToggle={() => toggle(index)}
        />
      ))}
    </div>
  )
}

export default SportsBeerAccordion
